import { render } from "./DialogPaymentLayoutHeader.vue?vue&type=template&id=6fa41c2e&ts=true"
import script from "./DialogPaymentLayoutHeader.vue?vue&type=script&lang=ts"
export * from "./DialogPaymentLayoutHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__